import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';

import './SiteLinkTitleCounter.css';

export interface SiteLinkTitleCounterProps {
    limit: number;
    availableFirstBlock: number;
    availableSecondBlock?: number;
}

const BLOCK = 'sitelink-title-counter';

export class SiteLinkTitleCounter extends React.Component<
    SiteLinkTitleCounterProps
> {
    render() {
        const { limit, availableFirstBlock, availableSecondBlock } = this.props;

        return (
            <span className={Bem.cls(BLOCK)}>
                <span
                    className={Bem.cls(BLOCK, 'count', {
                        error: limit < 0
                    })}
                >
                    {limit}
                </span>
                /
                <span
                    className={Bem.cls(BLOCK, 'count', {
                        error: availableFirstBlock < 0
                    })}
                >
                    {availableFirstBlock}
                </span>
                {availableSecondBlock !== undefined && (
                    <>
                        /
                        <span
                            className={Bem.cls(BLOCK, 'count', {
                                error: availableSecondBlock < 0
                            })}
                        >
                            {availableSecondBlock}
                        </span>
                    </>
                )}
            </span>
        );
    }
}
